import angular from "angular";

angular
	.module('app')
	.component('carHistoryApplicationsPage', {
		template: require('./car-history-applications-page.html'),
        controller: ['$http', 'moment', controller],
        bindings: {
            applications: '<',
            car: '<',
            startDate: '@',
            endDate: '@',
        }
    });

function controller($http, moment) {

	let $ctrl = this;

	$ctrl.$onInit = function () {
        $ctrl.nowDate = moment();
        $ctrl.applications.forEach((app, ind) => app.show = !ind);
    };

	$ctrl.showApp = function (app) {
	    app.show = !app.show;
    }
}
